import React, {useContext} from "react";
import classNames from "classnames";
import PropTypes from "prop-types";
import { makeStyles } from "@material-ui/core/styles";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import IconButton from "@material-ui/core/IconButton";
import Button from "@material-ui/core/Button";
import Hidden from "@material-ui/core/Hidden";
import Drawer from "@material-ui/core/Drawer";
import Menu from "@material-ui/icons/Menu";
import styles from "assets/jss/material-kit-react/components/headerStyle.js";
import assets from 'assets';
import { useSelector, useDispatch } from "react-redux";

import kingsChatWebSdk from 'kingschat-web-sdk';
import { FirebaseContext } from 'common';
import 'kingschat-web-sdk/dist/stylesheets/style.min.css';
import 'assets/css/kings.css';

const axios = require('axios').default;

//localStorage.removeItem('userId');

const loginOptions = {
  // Scopes is an Array of scopes you want access
  scopes: ["user"], // ex. ["send_chat_message"]
  // Your clientId generated on KingsChat's Developer Site
  clientId: "c666876e-6714-46f6-90d3-a6b3cffc6688" // ex. 'a1234567-abcd-1234-abcd-12345abc1234'
}

const sendMessageOptions = {

}

const refreshAuthenticationTokenOptions = {

}

let popUpObj;

    function showModalPopUp(url)

    {

    popUpObj=window.open(url,

    "ModalPopUp",

    "toolbar=no," +

    "scrollbars=no," +

    "location=no," +

    "statusbar=no," +

    "menubar=no," +

    "resizable=0," +

    "width=400," +

    "height=450," +

    "left = 490," +

    "top=300"

    );

    popUpObj.focus();

    LoadModalDiv();

    }
function LoadModalDiv()

    {

        var bcgDiv = document.getElementById("divBackground");

        bcgDiv.style.display="block";

    }
function HideModalDiv()

     {

        var bcgDiv = document.getElementById("divBackground");

        bcgDiv.style.display="none";

     }

function loginWithKingsChatx() {
  //localStorage.removeItem('userId');
  //const dispatch = useDispatch();
  const newUserId = localStorage.getItem('userId');
    if(newUserId ) {
      //console.log(newUserId);
      showModalPopUp("https://www.jekalo.com/kingspayout.php?&gateway=kingspay&lid="+newUserId+"&amt="+2500)

     
      //this.kingsclass = "kingsPay"
    } else {
      kingsChatWebSdk.login(loginOptions)
      .then(authenticationTokenResponse => {
        authenticationTokenResponse['web'] = true;

        axios.post('https://jekalo.com/kingschatweb.php', authenticationTokenResponse)
        .then(function (response) {
          //console.log(response.data);
          localStorage.setItem('userId', response.data.user_id);
          localStorage.setItem('customToken', response.data.customToken);
          //dispatch(SignInToken());

          //document.getElementById('kingId').classList.add('kingsPay');
          //document.getElementById('kingId').classList.remove(kingsclass);

          //localStorage.setItem('Password', pwd);
        })
        .catch(function (error) {
          console.log(error);
        });
      })
      .catch(error => {console.log("error", error)});
  }
}
function refreshKingsChatAuthenticationToken() {
  kingsChatWebSdk.refreshAuthenticationToken(refreshAuthenticationTokenOptions)
  .then(authenticationTokenResponse => {})
  .catch(error => {});
}
function sendKingsChatMessageRequest() {
  kingsChatWebSdk.sendMessage(sendMessageOptions)
  .then(() => {})
  .catch(error => {});
}

const useStyles = makeStyles(styles);

export default function Header(props) {
  const { api} = useContext(FirebaseContext);
  
  const {
    SignInToken,
    signOut
  } = api;
  
  const dispatch = useDispatch();

  //dispatch(signOut());
  const storageUserId = localStorage.getItem('userId');
  const storageObj = localStorage.getItem('tokenObj');
  if(storageUserId && !storageObj) {
    localStorage.removeItem('userId');
  }

  const classes = useStyles();
  const [mobileOpen, setMobileOpen] = React.useState(false);
  const [secondLogo,setSecondLogo] = React.useState(false);
  const kingsclassDef = localStorage.getItem('userId') ? "kingsPay": "kc-web-sdk-btn";
  const [kingsClass, setKingsClass] = React.useState(kingsclassDef);
  React.useEffect(() => {
    if (props.changeColorOnScroll) {
      window.addEventListener("scroll", headerColorChange);
    }
    return function cleanup() {
      if (props.changeColorOnScroll) {
        window.removeEventListener("scroll", headerColorChange);
      }
    };
  });

  const loginWithKingsChat = (e) => {
    e.preventDefault();
    //localStorage.removeItem('userId');
    
    const newUserId = localStorage.getItem('userId');
      if(newUserId ) {
        console.log(newUserId);
        showModalPopUp("https://www.jekalo.com/kingspayout.php?&gateway=kingspay&lid="+newUserId+"&amt="+2500)
  
       
        //this.kingsclass = "kingsPay"
      } else {
        kingsChatWebSdk.login(loginOptions)
        .then(authenticationTokenResponse => {
          authenticationTokenResponse['web'] = true;
  
          axios.post('https://jekalo.com/kingschatweb.php', authenticationTokenResponse)
          .then(function (response) {
            console.log(response.data);
            localStorage.setItem('userId', response.data.user_id);
            localStorage.setItem('tokenObj', JSON.stringify(response.data));
            /*
            const {
              SignInToken
            } = api;
            */

            setKingsClass('kingsPay');

            //document.getElementById('kingId').classList.add('kingsPay');
            //document.getElementById('kingId').classList.remove(kingsclass);

            dispatch(SignInToken());
  
            
  
            //localStorage.setItem('Password', pwd);
          })
          .catch(function (error) {
            console.log(error);
          });
        })
        .catch(error => {console.log("error", error)});
    }
  }
  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };
  const headerColorChange = () => {
    const { color, changeColorOnScroll } = props;
    const windowsScrollTop = window.pageYOffset;
    if (windowsScrollTop > changeColorOnScroll.height) {
      document.body
        .getElementsByTagName("header")[0]
        .classList.remove(classes[color]);
      document.body
        .getElementsByTagName("header")[0]
        .classList.add(classes[changeColorOnScroll.color]);
      setSecondLogo(true);
    } else {
      document.body
        .getElementsByTagName("header")[0]
        .classList.add(classes[color]);
      document.body
        .getElementsByTagName("header")[0]
        .classList.remove(classes[changeColorOnScroll.color]);
      setSecondLogo(false);
    }
  };
  const { color, rightLinks, leftLinks, fixed, absolute } = props;
  const appBarClasses = classNames({
    [classes.appBar]: true,
    [classes[color]]: color,
    [classes.absolute]: absolute,
    [classes.fixed]: fixed
  });
  const brandComponent = <Button 
                              href="/"
                              className={classes.title}>
                              {secondLogo?<img src={assets.logo138x75black} alt="Logo" />:
                                  <img src={assets.logo138x75white} alt="Logo" />
                              }
                         </Button>;
  return (
    <AppBar className={appBarClasses}>
      <Toolbar className={classes.container}>
        {leftLinks !== undefined ? brandComponent : null}
        <div className={classes.flex}>
          {leftLinks !== undefined ? (
            <Hidden smDown implementation="css">
              {leftLinks}
            </Hidden>
          ) : (
            brandComponent
          )}
        </div>
        <Hidden smDown implementation="css">
          {rightLinks}
        </Hidden>
        <Hidden mdUp>
          <IconButton
            color="inherit"
            aria-label="open drawer"
            onClick={handleDrawerToggle}
          >
            <Menu />
          </IconButton>
        </Hidden>
      </Toolbar>
      <Hidden mdUp implementation="js">
        <Drawer
          variant="temporary"
          anchor={"right"}
          open={mobileOpen}
          classes={{
            paper: classes.drawerPaper
          }}
          onClose={handleDrawerToggle}
        >
          <div className={classes.appResponsive}>
            {leftLinks}
            {rightLinks}
          </div>
        </Drawer>
      </Hidden>
      <div
      style={{
        paddingRight: 100
      }}
      ><a className={kingsClass} id="kingId" onClick={loginWithKingsChat} /></div>
      <div id ="divBackground" style={{position: fixed, zIndex: 999, height: "100%", width: "100%", top: 0, left:0, backgroundColor: "Black", filter: "alpha(opacity=60)", opacity: 0.6, MozOpacity: 0.8,display:"none"}}>

</div>
    </AppBar>
  );
}

Header.defaultProp = {
  color: "white"
};

Header.propTypes = {
  color: PropTypes.oneOf([
    "primary",
    "info",
    "success",
    "warning",
    "danger",
    "transparent",
    "white",
    "rose",
    "dark"
  ]),
  rightLinks: PropTypes.node,
  leftLinks: PropTypes.node,
  brand: PropTypes.string,
  fixed: PropTypes.bool,
  absolute: PropTypes.bool,
  changeColorOnScroll: PropTypes.shape({
    height: PropTypes.number.isRequired,
    color: PropTypes.oneOf([
      "primary",
      "info",
      "success",
      "warning",
      "danger",
      "transparent",
      "white",
      "rose",
      "dark"
    ]).isRequired
  })
};
